




































import Vue, { PropType } from 'vue'
import { TreeviewUser, UserStats } from '@/api/Auth/auth.interface'
import { getUserTree, getUserStats } from '@/api/Users/users.api'
import UserStatsVue from './UserStats.vue'
import ActionButton from '@/components/ActionButton.vue'
import RemoveNetCredit from '@/components/Services/TopUps/RemoveNetCredit.vue'
import { RemoveCreditDTO } from '@/utils/interfaces/topup.interface'
export default Vue.extend({
  components: {
    appUserStats: UserStatsVue,
    appActionButton: ActionButton,
    appRemoveNetCredit: RemoveNetCredit,
  },
  props: {
    item: Object as PropType<TreeviewUser>,
  },
  data: function() {
    return {
      active: [],
      open: [],
      items: [{ ...this.item, children: [] }] as TreeviewUser[],
      loadingItem: null as null | TreeviewUser,
      detailsItem: null as null | UserStats,
      detailsDialog: false,
    }
  },
  methods: {
    async loadItems(item: TreeviewUser) {
      const response = await getUserTree(item.uuid)
      response.data.results.forEach((user: TreeviewUser) => {
        user.children = []
      })
      item.children = response.data.results
    },
    async seeDetails(item: TreeviewUser) {
      this.loadingItem = item
      try {
        const response = await getUserStats(item.uuid)
        this.detailsItem = response.data
        this.detailsDialog = true
      } finally {
        this.loadingItem = null
      }
    },
    onRemoved(data: RemoveCreditDTO) {
      this.item.topup_credit = data.credit
      this.$emit('refresh', data)
    },
  },
})
